import { useState, useEffect } from "react";
import { doc, onSnapshot, updateDoc, arrayUnion } from "firebase/firestore";
import { db } from "../firebase";
import Chat from "./Chat";

export default function GameBoard({ gameId, player }) {
  const [guess, setGuess] = useState("");
  const [gameData, setGameData] = useState(null);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const gameRef = doc(db, "games", gameId);
    
    const unsubscribe = onSnapshot(gameRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();
        setGameData(data);
        setHistory(data.history || []);
      }
    });

    return () => unsubscribe();
  }, [gameId]);

  const handleSubmit = async () => {
    if (guess.length !== 4 || isNaN(guess)) {
      alert("4자리 숫자를 입력하세요.");
      return;
    }

    // 🔹 자신의 턴이 아닐 경우 입력 불가능
    if (gameData?.turn !== player) {
      alert("현재 당신의 턴이 아닙니다!");
      return;
    }

    const answer = player === "red" ? gameData.blueAnswer : gameData.redAnswer;

    if (!answer) {
      alert("상대 플레이어가 아직 숫자를 설정하지 않았습니다!");
      return;
    }

    let strike = 0, ball = 0;
    for (let i = 0; i < 4; i++) {
      if (guess[i] === answer[i]) strike++;
      else if (answer.includes(guess[i])) ball++;
    }

    const gameRef = doc(db, "games", gameId);
    await updateDoc(gameRef, {
      history: arrayUnion({
        player,
        guess,
        strike,
        ball,
        timestamp: new Date().toISOString()
      }),
      turn: player === "red" ? "blue" : "red"  // 🔹 턴 변경
    });

    setGuess("");
  };

  const handlePassTurn = async () => {
    if (gameData?.turn !== player) {
      alert("현재 당신의 턴이 아닙니다!");
      return;
    }

    const gameRef = doc(db, "games", gameId);
    await updateDoc(gameRef, {
      turn: player === "red" ? "blue" : "red",  // 🔹 턴을 즉시 상대방에게 넘김
      history: arrayUnion({
        player,
        action: "pass",
        timestamp: new Date().toISOString()
      })
    });

    alert("턴을 패스했습니다.");
  };

  return (
    <div className="container">
      <h1>숫자 야구 게임</h1>
      <p>현재 차례: {gameData?.turn === "red" ? "🔴 Red" : "🔵 Blue"}</p>

      {/* 🔹 자신의 턴일 때만 입력 가능 */}
      {gameData?.turn === player ? (
        <>
          <input 
            type="text" 
            value={guess} 
            onChange={(e) => setGuess(e.target.value)} 
            maxLength="4"
            placeholder="4자리 숫자 입력" 
          />
          <button onClick={handleSubmit} className="green-btn">제출</button>
          <button onClick={handlePassTurn} className="blue-btn">턴 패스</button> {/* 🔹 턴 패스 버튼 */}
        </>
      ) : (
        <p className="text-gray-400">❌ 현재 당신의 턴이 아닙니다.</p>
      )}

      {/* 🔹 게임 기록을 양옆으로 나누어 표시 */}
      <div className="history-container">
        <div className="history red-history">
          <h2 className="text-red-500">Red 팀</h2>
          {history.filter(entry => entry.player === "red").map((entry, index) => (
            <p key={index} className="history-entry">
              {entry.action === "pass"
                ? "턴 패스"
                : `${entry.guess} → ${entry.strike}S ${entry.ball}B`
              }
            </p>
          ))}
        </div>

        <div className="history blue-history">
          <h2 className="text-blue-500">Blue 팀</h2>
          {history.filter(entry => entry.player === "blue").map((entry, index) => (
            <p key={index} className="history-entry">
              {entry.action === "pass"
                ? "턴 패스"
                : `${entry.guess} → ${entry.strike}S ${entry.ball}B`
              }
            </p>
          ))}
        </div>
      </div>

      {/* 🔹 실시간 채팅 */}
      <Chat gameId={gameId} player={player} />
    </div>
  );
}
